export default __webpack_public_path__ + "static/media/central_management_icon.7c9b298e.svg";